import { OFFER_TYPE_HOTEL } from 'constants/offer'

function isFlashSearchMetaData(metaData: App.OfferListMetaData): boolean {
  return metaData.type === OFFER_TYPE_HOTEL || metaData.pricing?.rateType === 'reservation'
}

export function shouldWaitForLereSearchPricingIdentity(metaData: App.OfferListMetaData): boolean {
  return isFlashSearchMetaData(metaData)
    && !!metaData.available
    && !metaData.pricing?.lowestPriceRoomRateId
}

export function isFlashSearchResultEligibleForLereDynamicPricing(
  metaData: App.OfferListMetaData,
  eligibleRoomRateIds: Set<string>,
): boolean {
  const roomRateId = metaData.pricing?.lowestPriceRoomRateId
  if (!roomRateId || !isFlashSearchMetaData(metaData)) {
    return false
  }

  return eligibleRoomRateIds.has(roomRateId)
}

export function hasEligibleFlashSearchResult(
  offerMetaData: Record<string, App.OfferListMetaData | undefined> | undefined,
  eligibleRoomRateIds: Set<string>,
): boolean {
  if (!offerMetaData) {
    return false
  }

  return Object.values(offerMetaData).some(metaData =>
    metaData
    && !shouldWaitForLereSearchPricingIdentity(metaData)
    && isFlashSearchResultEligibleForLereDynamicPricing(metaData, eligibleRoomRateIds),
  )
}
